const video = document.getElementById("background-video");
const loader = document.getElementById("video-loader");

if (video) {
  video.addEventListener("canplaythrough", () => {
    loader.style.display = "none";
  });
}
